import { render } from "./_faqIdx.vue?vue&type=template&id=196ece14"
import script from "./_faqIdx.vue?vue&type=script&lang=js"
export * from "./_faqIdx.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__